// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change the dropdown background and text color */
.ms-parent, .ms-choice {
    --ms-checkbox-color: var(--accent1);
    --ms-select-all-text-color: var(--accent1);
    --ms-choice-focus-border-color: var(--accent3);
    --ms-choice-focus-box-shadow: var(--accent3);
    --ms-option-highlight-bg-color: var(--accent4);
    --ms-placeholder-color: var(--dark-text);
    --ms-drop-hide-radio-selected-bgcolor: var(--accent1);

    font-size: .9rem;
    line-height: 1.5;
    width: 100% !important;
}

.ms-choice {
    padding: 0.2rem 0.4rem;
    height: auto;
    gap: 0.4rem;
}

.multi-select {
    padding: 0.2rem;
}

.multiselect--inline {
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/multiple-select/multiple-select.custom.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,8CAA8C;IAC9C,4CAA4C;IAC5C,8CAA8C;IAC9C,wCAAwC;IACxC,qDAAqD;;IAErD,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["/* Change the dropdown background and text color */\n.ms-parent, .ms-choice {\n    --ms-checkbox-color: var(--accent1);\n    --ms-select-all-text-color: var(--accent1);\n    --ms-choice-focus-border-color: var(--accent3);\n    --ms-choice-focus-box-shadow: var(--accent3);\n    --ms-option-highlight-bg-color: var(--accent4);\n    --ms-placeholder-color: var(--dark-text);\n    --ms-drop-hide-radio-selected-bgcolor: var(--accent1);\n\n    font-size: .9rem;\n    line-height: 1.5;\n    width: 100% !important;\n}\n\n.ms-choice {\n    padding: 0.2rem 0.4rem;\n    height: auto;\n    gap: 0.4rem;\n}\n\n.multi-select {\n    padding: 0.2rem;\n}\n\n.multiselect--inline {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
